module.exports = __webpack_public_path__ + "media/images/webpage/hotels/7167/plan4-2-df3bb2431b783b6729fbefaa25682a49.webp";